/**
 * Fallback country covers when admin has not uploaded a banner.
 *
 * Priority (CountryImagesContext):
 * 1. Admin / API CDN banners that actually load (never /static/, never Wikipedia)
 * 2. Generic travel photo sized for 4:5 cards
 */

/** ~440×550 display; keep payload small for mobile cards. */
const GENERIC_TRAVEL_PHOTO =
  'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?auto=format&fit=crop&w=440&h=550&q=60';

/** Reject Nest `/static/` uploads and Wikipedia — both cause 404s / 3rd-party cookies. */
export function isUsableCountryImageUrl(url?: string | null): boolean {
  if (!url) return false;
  const u = String(url).trim();
  if (!u) return false;
  if (/\/static\//i.test(u)) return false;
  if (/wikimedia\.org|wikipedia\.org/i.test(u)) return false;
  return true;
}

/**
 * Prefer card-sized Unsplash variants. R2/CDN URLs pass through
 * (recompress those assets in storage — see backend image quality settings).
 */
export function optimizeCountryImageUrl(url: string): string {
  if (!url) return url;
  try {
    const u = new URL(url);
    if (u.hostname.includes('images.unsplash.com')) {
      u.searchParams.set('auto', 'format');
      u.searchParams.set('fit', 'crop');
      u.searchParams.set('w', '440');
      u.searchParams.set('h', '550');
      u.searchParams.set('q', '60');
      return u.toString();
    }
  } catch {
    /* keep original */
  }
  return url;
}

/** Sync placeholder — never a flag / never Wikimedia / never Nest static. */
export function getFallbackCountryImageUrl(_countryCode?: string): string {
  return GENERIC_TRAVEL_PHOTO;
}

/** @deprecated Prefer useCountryImages().getImage */
export function getCountryImageUrl(countryCode: string): string {
  return getFallbackCountryImageUrl(countryCode);
}

/** No-op: landmark fetching removed (Wikipedia hotlinking deleted). */
export async function fetchCountryLandmarkPhoto(_countryCode: string): Promise<string | null> {
  return null;
}

export function getCachedLandmarkUrl(_countryCode: string): string | null {
  return null;
}
